'use client';

import CampaignSession from '../session/campaign-session';
import StoreList from '../store-list-client';
import { useGetStores } from '@/api/use-get-store';
import type { PageContentProps } from '@/types/page-types';

export default function CampaignPageContent({ payload }: PageContentProps) {
  const { data: storesData } = useGetStores(payload, {
    enabled: !!payload.campaign_id,
  });

  if (!payload.campaign_id) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF7F2] to-white md:bg-white md:bg-none">
      <div className="mx-auto max-w-6xl px-4 py-6 lg:px-8">
        <CampaignSession
          campaignId={payload.campaign_id}
          city={payload.city_id}
        />
        <StoreList payload={payload} data={storesData?.stores ?? []} />
      </div>
    </div>
  );
}
